export default function reviews(
  state = {
    dailySummaries: [],
    latestDetails: [],
    dailyReviews: [],
    isLoading: false,
    error: null
  },
  action
) {
  switch (action.type) {
    case 'GET_REVIEW_REQUESTS_STARTED':
      return {
        ...state,
        isLoading: true
      }

    case 'GET_REVIEW_REQUESTS_FAILED':
      return {
        ...state,
        error: action.payload.message,
        isLoading: false
      }

    case 'GOT_REVIEW_REQUESTS':
      return {
        ...state,
        dailySummaries: action.payload.reviewRequests.dailySummaries.map(summary => ({
          ...summary,
          key: summary.requestDate
        })),
        latestDetails: action.payload.reviewRequests.latestDetails.map(detail => ({
          ...detail,
          key: detail.reviewId
        })),
        isLoading: false,
        error: null
      }

    case 'GOT_DAILY_REVIEWS':
      return {
        ...state,
        dailyReviews: action.payload.map(review => ({
          ...review,
          key: review.reviewId
        }))
      }

    default:
      return state
  }
}
